import { ExtendedView } from 'views/store/common/utility/view/view';
import { Collection } from 'views/store/common/utility/adt/collection';

import { ProjectChecklistView } from 'views/store/pages/account/projects/roomchecklists/project_checklist';

import 'store/global/common/projects/roomchecklists/_step_1.dust';
import 'store/global/common/projects/roomchecklists/_step_2.dust';

import { ProjectChecklistsModel } from 'models/store/client/projects/roomchecklists/project_checklists';

import { StatusEvents, StatusGet } from 'store/pages/account/projects/common/status/project_status';

export class CreateProjectSteps extends ExtendedView {
	static events = {};
	events() {
		return {
			'click .js-create-new-project-next': 'onCreateNewProjectClick',
			'click .js-create-new-blank-project': 'onCreateNewBlankProjectClick',
			'click .js-checklists-prev': 'onRoomChecklistPrevClick',
			'click .js-checklists-next': 'onRoomChecklistNextClick',
			'click .js-create-project-button': 'onCreateProjectClick',
			'keyup .js-project-name': 'onProjectNameInputKeyup'
		};
	}

	preinitialize(options) {
		super.preinitialize(options);
	}

	initialize(options = {}) {
		super.initialize(options);
		this.projectId = options.projectId;
		this.createNewBlankOverride = options.createNewBlankOverride;
	}

	getDefaults() {
		return Object.assign(super.getDefaults(), {
			_views: new Collection([], { _interface: ProjectChecklistView })
		});
	}

	targetChecklistEl() {
		return this.$checklists;
	}

	cache() {
		this.$loadingOverlay = this.$el.find('.js-loading-overlay');
		this.$step1 = this.$el.find('[data-id="step1"]');
		this.$step2 = this.$el.find('[data-id="step2"]');
		this.$createNewProjectNext = this.$el.find('.js-create-new-project-next');
		this.$checklists = this.$el.find('.js-checklist-list');
		this.$prev = this.$el.find('.js-checklists-prev');
		this.$next = this.$el.find('.js-checklists-next');
		this.$projectNameInput = this.$el.find('.js-project-name');
		this.$createProjectButton = this.$el.find('.js-create-project-button');
		this.$errorInputBox = this.$el.find('.js-input-error-box');
		this.$modalTitle = this.$el.find('.js-modal-title');
		return this;
	}

	update() {
		this.views
			.invoke('remove')
			.set(this.model.get('paginated').map(this.createChecklist, this))
			.invoke('render');
		this.model.changeStep(ProjectChecklistsModel.steps.step1);
		return this.updatePagination().statuses();
	}

	updatePagination() {
		this.model.hasPrev() ? this.$prev.removeClass('hide') : this.$prev.addClass('hide');
		this.model.hasNext() ? this.$next.removeClass('hide') : this.$next.addClass('hide');
		return this;
	}

	statuses() {
		StatusGet({ rootEl: this.$el })
			.on(StatusEvents.slow, this.onSlowRequest, this)
			.on(StatusEvents.complete, this.onSlowRequestComplete, this);
		return this;
	}

	createChecklist(model) {
		return { model, _parent: this, _targetEl: this.targetChecklistEl.bind(this) };
	}

	reset() {
		this.model.changeStep(ProjectChecklistsModel.steps.step1).clearSelection();
		return this;
	}

	validateProjectName(value) {
		const result = value.length > 0;
		result ? this.enableButton(this.$createProjectButton) : this.disableButton(this.$createProjectButton);
		return result;
	}

	changeStep($current, show = false) {
		show ? $current.removeClass('hide') : $current.addClass('hide');
		return this;
	}

	changeToStep(step) {
		if (step === ProjectChecklistsModel.steps.step1) {
			this.changeStep(this.$step1, true).changeStep(this.$step2, false);
			this.$modalTitle.text('Which rooms are you working on?');
		} else {
			this.changeStep(this.$step1, false).changeStep(this.$step2, true);
			this.$modalTitle.text("What is your project's name?");
		}
		return this;
	}

	enableButton($button) {
		$button.removeAttr('disabled').removeClass('o-50 not-allowed');
		return this;
	}

	disableButton($button) {
		$button.attr('disabled', 'disabled').addClass('o-50 not-allowed');
		return this;
	}

	onSelectionChange() {
		this.model.isAnythingSelected() ? this.enableButton(this.$createNewProjectNext) : this.disableButton(this.$createNewProjectNext);
		return this;
	}

	onCreateNewProjectClick(e) {
		e.preventDefault();
		this.model.changeStep(ProjectChecklistsModel.steps.step2);
		return this;
	}

	onCreateNewBlankProjectClick(e) {
		e.preventDefault();
		if (this.createNewBlankOverride) {
			this.createNewBlankOverride();
			return this;
		}
		this.model.clearSelection().changeStep(ProjectChecklistsModel.steps.step2);
		return this;
	}

	onProjectNameInputKeyup(e) {
		e.preventDefault();
		const projectName = $(e.currentTarget).val();
		if (projectName && e.keyCode === 13) {
			return this.onCreateProjectClick(e);
		}
		if (this.validateProjectName(projectName)) {
			this.model.set('projectName', projectName);
		}
		return this;
	}

	onCreateProjectClick(e) {
		e.preventDefault();
		StatusGet().show('createProject');
		this.model.set('createDefaultGroup', true);
		this.model.createProject(this.onSuccess.bind(this), this.onError.bind(this));
		return this.disableButton(this.$createProjectButton);
	}

	onRoomChecklistPrevClick(e) {
		e.preventDefault();
		this.model.prev();
		return this;
	}

	onRoomChecklistNextClick(e) {
		e.preventDefault();
		this.model.next();
		return this;
	}

	onSlowRequest() {
		this.$loadingOverlay.removeClass('hide');
		return this;
	}

	onSlowRequestComplete() {
		this.$loadingOverlay.addClass('hide');
		return this;
	}

	onSuccess() {
		return StatusGet().hide('createProject');
	}

	onError(model, error) {
		StatusGet().hide('createProject');
		this.enableButton(this.$createProjectButton);
		this.handleCreateProjectError(JSON.parse(error.responseText).message);
	}

	handleCreateProjectError(message) {
		this.$errorInputBox.html(message).removeClass('hide');
		this.$projectNameInput.one('keyup', () => this.$errorInputBox.html('').addClass('hide'));
	}
}
